// apps/patient/src/components/messages/ThreadList.tsx

import { formatDistanceToNow } from 'date-fns';
import { 
  User, 
  Clock, 
  AlertCircle, 
  Paperclip,
  Circle,
  CheckCircle,
  Archive
} from 'lucide-react';
import { cn } from '../../lib/utils';
import ThreadListItem from './ThreadListItem';

export default function ThreadList({ 
  threads, 
  selectedThread, 
  onThreadSelect, 
  onMarkRead,
  isThreadUnread 
}) {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'urgent':
        return 'text-red-600 bg-red-50 border-red-200';
      case 'high':
        return 'text-orange-600 bg-orange-50 border-orange-200';
      case 'medium':
        return 'text-yellow-600 bg-yellow-50 border-yellow-200';
      case 'low':
        return 'text-gray-600 bg-gray-50 border-gray-200';
      default:
        return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };
  
  const getCategoryColor = (category) => {
    switch (category) {
      case 'clinical':
        return 'bg-blue-100 text-blue-700';
      case 'administrative':
        return 'bg-gray-100 text-gray-700';
      case 'billing':
        return 'bg-green-100 text-green-700';
      case 'prescription':
        return 'bg-purple-100 text-purple-700';
      case 'appointment':
        return 'bg-indigo-100 text-indigo-700';
      case 'lab_results':
        return 'bg-pink-100 text-pink-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };
  
  const getStatusIcon = (status) => {
    switch (status) {
      case 'open':
        return <Circle className="h-4 w-4 text-green-500" />;
      case 'closed':
        return <CheckCircle className="h-4 w-4 text-gray-400" />;
      case 'archived':
        return <Archive className="h-4 w-4 text-gray-400" />;
      case 'awaiting_response':
        return <Clock className="h-4 w-4 text-yellow-500" />;
      default:
        return null;
    }
  };
  
  return (
    <div className="divide-y divide-gray-100">
      {threads.map(thread => (
        <ThreadListItem
          key={thread.id}
          thread={thread}
          isSelected={selectedThread?.id === thread.id}
          isUnread={isThreadUnread(thread)}
          onSelect={() => onThreadSelect(thread)}
          onMarkRead={() => onMarkRead(thread.id)}
          getPriorityColor={getPriorityColor}
          getCategoryColor={getCategoryColor}
          getStatusIcon={getStatusIcon}
        />
      ))}
    </div>
  );
}
